import React, { useEffect, useState } from 'react';
import { Check, AlertCircle, Star, Shield, ShieldCheck, Zap, Activity, Server, ChevronRight, Lock, BarChart } from 'lucide-react';
import Header from '../components/Header';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';

export default function PricingPage() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [activeTab, setActiveTab] = useState('monthly');
  
  return (
    <div>
        <Header />
    <div className="bg-gradient-to-b from-black to-gray-900 min-h-screen text-gray-100">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 pt-16 pb-8 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-6xl">
          Plans for Every Stage of Growth
        </h1>
        <p className="mt-5 max-w-3xl mx-auto text-xl text-gray-300">
          Monthly Pricing Based on Annual Subscription
        </p>
        <div className="mt-3 inline-flex items-center justify-center bg-blue-900 rounded-full px-4 py-2 text-sm font-medium text-blue-200">
          <AlertCircle className="h-4 w-4 mr-2" />
          Risk Free! Opt Out Anytime During the First 30 Days
        </div>
        
        <div className="mt-3 flex flex-col items-center justify-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-4">
          <span className="inline-flex items-center text-sm font-medium text-gray-300">
            <Check className="h-4 w-4 text-green-400 mr-1" />
            White Glove Onboarding Included
          </span>
          <span className="inline-flex items-center text-sm font-medium text-gray-300">
            <Check className="h-4 w-4 text-green-400 mr-1" />
            Special Startup Pricing Available
          </span>
        </div>
      </div>

      {/* Pricing Cards Section */}
      <div className="max-w-7xl mx-auto px-4 pb-24 sm:px-6 lg:px-8">
        <div className="mt-12 space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:space-y-0">
          {/* DevOps Plan */}
          <div className="relative flex flex-col rounded-2xl border border-gray-700 bg-gray-800 p-8 shadow-md transition-all hover:shadow-lg hover:border-blue-500">
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-white">DevOps</h3>
              <div className="mt-4 flex items-baseline text-white">
                <span className="text-5xl font-extrabold tracking-tight">$3,000</span>
                <span className="ml-1 text-xl font-semibold">/month</span>
              </div>
              <p className="mt-2 text-sm text-gray-400">First 25 Nodes**</p>
              
              <p className="mt-6 text-lg font-medium text-white">Automate Application Deployment</p>
              
              <ul className="mt-6 space-y-4">
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Check className="h-5 w-5 text-green-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">Automates AWS/AZURE/GCP Services</p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Server className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Platform:</span> VMs, DBs, ES, 50+ other services
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Zap className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">App Deployment:</span> Containers, Serverless, Kubeflow/ETL
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Activity className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Standard Diagnostics/Observability:</span> Monitoring, Logging, Alerting
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <BarChart className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">CI/CD:</span> Build, Deploy, DAST, SAST
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Shield className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Security:</span> Best practices, baseline controls
                  </p>
                </li>
              </ul>
            </div>
            <Link to='/contact'>
            <button className="mt-8 block w-full rounded-md border border-blue-500 bg-gray-800 px-6 py-3 text-center text-base font-medium text-blue-400 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800">
              CONTACT US
            </button>
            </Link>
          </div>
          
          {/* DevSecOps Plan */}
          <div className="relative flex flex-col rounded-2xl border border-blue-500 bg-gray-800 p-8 shadow-lg transition-all hover:shadow-xl">
            <div className="absolute top-0 -translate-y-1/2 transform rounded-full bg-blue-600 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-white">
              POPULAR
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-white">DevSecOps</h3>
              <div className="mt-4 flex items-baseline text-white">
                <span className="text-5xl font-extrabold tracking-tight">$4,500</span>
                <span className="ml-1 text-xl font-semibold">/month</span>
              </div>
              <p className="mt-2 text-sm text-gray-400">First 50 Nodes**</p>
              
              <p className="mt-6 text-lg font-medium text-white">Compliance + Security Controls</p>
              
              <ul className="mt-6 space-y-4">
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Check className="h-5 w-5 text-green-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300 font-medium">Includes all features of DevOps</p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Shield className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Compliance:</span> SOC 2, ISO 27001, HIPAA, GDPR
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Lock className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Security:</span> Vulnerability Assessment, Encryption, Virus Scanning, and other controls per compliance requirements
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <BarChart className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Audit & Reporting:</span> Audit Evidence, IT Questionnaires
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <ShieldCheck className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    Customer-facing Security White paper
                  </p>
                </li>
              </ul>
            </div>
            <Link to='/contact'>
            <button className="mt-8 block w-full rounded-md border border-transparent bg-blue-600 px-6 py-3 text-center text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800">
              CONTACT US
            </button>
            </Link>
          </div>
          
          {/* DevSecOps PLUS Plan */}
          <div className="relative flex flex-col rounded-2xl border border-gray-700 bg-gray-800 p-8 shadow-md transition-all hover:shadow-lg hover:border-blue-500">
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-white">DevSecOps PLUS</h3>
              <div className="mt-4 flex items-baseline text-white">
                <span className="text-5xl font-extrabold tracking-tight">$6,500</span>
                <span className="ml-1 text-xl font-semibold">/month</span>
              </div>
              <p className="mt-2 text-sm text-gray-400">First 50 Nodes**</p>
              
              <p className="mt-6 text-lg font-medium text-white">Advanced Regulatory Standards</p>
              
              <ul className="mt-6 space-y-4">
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Check className="h-5 w-5 text-green-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300 font-medium">Includes all features of DevSecOps</p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <ShieldCheck className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Advanced Security:</span> SIEM, HIDS, granular tenant permission sets and other controls per NIST requirements
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Shield className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    <span className="font-medium text-gray-200">Compliance:</span> NIST, PCI, HITRUST, ITAR, FINRA
                  </p>
                </li>
                
                <li className="flex items-start">
                  <div className="flex-shrink-0">
                    <Server className="h-5 w-5 text-blue-400" />
                  </div>
                  <p className="ml-3 text-sm text-gray-300">
                    Cloud and/or On-premises
                  </p>
                </li>
              </ul>
            </div>
            <Link to='/contact'>
            <button className="mt-8 block w-full rounded-md border border-blue-500 bg-gray-800 px-6 py-3 text-center text-base font-medium text-blue-400 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800">
              CONTACT US
            </button>
            </Link>
          </div>
        </div>
        
        {/* Add-Ons Section */}
        <div className="mt-24">
          <h2 className="text-3xl font-extrabold text-white text-center">Add-Ons</h2>
          <p className="mt-4 max-w-2xl mx-auto text-center text-xl text-gray-300">
            More scale, control, & support
          </p>
          
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
            <div className="bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700 hover:border-blue-500 hover:shadow-lg transition-all">
              <Activity className="h-8 w-8 text-blue-400" />
              <h3 className="mt-4 text-lg font-medium text-white">Advanced Observability w/OpenTelemetry</h3>
              <p className="mt-2 text-base font-bold text-gray-200">$1,500/month</p>
             
            </div>
            
            <div className="bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700 hover:border-blue-500 hover:shadow-lg transition-all">
              <Lock className="h-8 w-8 text-blue-400" />
              <h3 className="mt-4 text-lg font-medium text-white">Penetration Testing</h3>
              <p className="mt-2 text-base font-bold text-gray-200">$4,800 once per year</p>
              
            </div>
            
            <div className="bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700 hover:border-blue-500 hover:shadow-lg transition-all">
              <Star className="h-8 w-8 text-blue-400" />
              <h3 className="mt-4 text-lg font-medium text-white">US-only Support</h3>
              <p className="mt-2 text-base font-bold text-gray-200">$2,000/month</p>
              
            </div>
            
            <div className="bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700 hover:border-blue-500 hover:shadow-lg transition-all">
              <ShieldCheck className="h-8 w-8 text-blue-400" />
              <h3 className="mt-4 text-lg font-medium text-white">FedRAMP Support</h3>
              <p className="mt-2 text-base font-bold text-gray-200">Contact Us</p>
             
            </div>
            
            <div className="bg-gray-800 rounded-lg shadow-md p-6 border border-gray-700 hover:border-blue-500 hover:shadow-lg transition-all">
              <Zap className="h-8 w-8 text-blue-400" />
              <h3 className="mt-4 text-lg font-medium text-white">Professional Services</h3>
              <p className="mt-2 text-base font-bold text-gray-200">Contact Us</p>
            
            </div>
          </div>
        </div>
        
        {/* Footer Notes */}
        
      </div>
    </div>
    <Footer/>
    </div>
  );
}